/**
 * BrandMarkV4 — PMS Shell v4 brand cluster (mark + optional wordmark).
 *
 * Co-located internal of `SidebarV4` (SCRUM-298 / MENU-2): the only consumer
 * is the sidebar header, so it lives in the sidebar folder and is NOT
 * re-exported from the barrel (plan Q2 — co-locate as sidebar-internal).
 *
 * Composes the canonical `@sparta/ui-kit` `BrandMark` primitive rather than
 * re-drawing the SVG: the design handoff's inline `BrandMarkV4` glyph is the
 * same rounded-square "D" the kit already ships, so the kit-first rule
 * (compose, don't hand-roll) applies. This wrapper adds the "Desata"
 * wordmark beside the mark, which the sidebar header shows when expanded
 * (`showWordmark={false}` on the collapsed rail).
 */
import * as React from 'react';
import { BrandMark } from '@sparta/ui-kit';

export interface BrandMarkV4Props {
  /** Mark size in pixels. Default 28 (handoff default). */
  readonly size?: number;
  /** Show the "Desata" wordmark beside the mark (hidden when collapsed). */
  readonly showWordmark?: boolean;
  /** Brand wordmark text. Default "Desata" (plan Q5). */
  readonly brand?: string;
}

export function BrandMarkV4({
  size = 28,
  showWordmark = true,
  brand = 'Desata',
}: BrandMarkV4Props): React.ReactElement {
  return (
    <span className="flex items-center gap-2.5 shrink-0">
      <BrandMark size={size} />
      {showWordmark ? (
        <span className="text-lg font-bold tracking-[-0.3px] text-[var(--fg-primary)]">
          {brand}
        </span>
      ) : null}
    </span>
  );
}
